namespace GeniuzPOS.Purchase {
    export class ReportPendingPODtColumns {
        static columnsKey = 'Purchase.ReportPendingPODt';
    }
}
